import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdv-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class PdvHomePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
